import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import { CLIENTS_DRAFTS_CACHE_KEY } from '../useGetClientDrafts';

const deleteClient = async (
  doFetch: ReturnType<typeof useFetch<void, { success: boolean; message: string }>>['doFetch'],
  clientId: number
) => {
  return doFetch(`/api/clients/${clientId}`, {
    method: 'DELETE',
  });
};

export function useDeleteClient() {
  const queryClient = useQueryClient();
  const { doFetch } = useFetch<void, { success: boolean; message: string }>();

  return useMutation({
    mutationFn: (clientId: number) => deleteClient(doFetch, clientId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CLIENTS_DRAFTS_CACHE_KEY] });
    },
  });
}
